import "@/App.css";
import "./demo/today.css";
import "./demo/inbox.css";
import "./demo/automation.css";
import "./demo/sourceBadge.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ExplainerRecord from "./pages/ExplainerRecord";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AuditPage from "./pages/AuditPage";
import StartPage from "./pages/StartPage";
import DemoLayout from "./demo/DemoLayout";
import Login from "./demo/Login";
import Today from "./demo/Today";
import Inbox from "./demo/Inbox";
import CRM from "./demo/CRM";
import LiveDemo from "./demo/LiveDemo";
import LiveDemo2 from "./demo/LiveDemo2";
import Settings from "./demo/Settings";
import LeadDetail from "./demo/LeadDetail";
import Automation from "./demo/Automation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/explainer-record" element={<ExplainerRecord />} />
          <Route path="/casestudies" element={<CaseStudiesPage />} />
          <Route path="/casestudies/:slug" element={<CaseStudiesPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/start" element={<StartPage />} />
          <Route path="/demo" element={<DemoLayout />}>
            <Route index element={<Login />} />
            <Route path="today" element={<Today />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="inbox/:leadId" element={<Inbox />} />
            <Route path="crm" element={<CRM />} />
            <Route path="live/:leadId" element={<LiveDemo />} />
            <Route path="live2/:leadId" element={<LiveDemo2 />} />
            <Route path="settings" element={<Settings />} />
            <Route path="automation" element={<Automation />} />
            {/* Legacy /demo/whatsapp redirected to unified Inbox */}
            <Route path="whatsapp" element={<Navigate to="/demo/inbox" replace />} />
            <Route path="lead/:leadId" element={<LeadDetail />} />
            {/* Common alias: /demo/login → the login (index) route. */}
            <Route path="login" element={<Navigate to="/demo" replace />} />
          </Route>
          {/* Catch-all → send everything else back to the landing page. */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
